import { useThemeUI as d, Box as i } from "theme-ui";
import { Slot as p } from "@radix-ui/react-slot";
import { jsx as t, Fragment as u } from "theme-ui/jsx-runtime";
const g = (e) => {
  const {
    variant: r = "base",
    enabled: s = !0,
    selector: l,
    applyToDisabled: n,
    children: o,
    asChild: a,
    ...c
  } = e, {
    theme: m
  } = d();
  return s ? /* @__PURE__ */ t(a ? p : i, {
    "data-loading": !0,
    ...c,
    sx: {
      [l ?? (n ? "&, &:disabled" : "&")]: m.skeletons[r],
      ...e.sx
    },
    children: o
  }) : /* @__PURE__ */ t(u, {
    children: o
  });
};
export {
  g as Skeleton
};
